export const CheckedState = {
  INDETERMINATE: 'indeterminate',
  CHECKED: 'checked',
  UNCHECKED: 'unchecked',
};
